import { Component } from '@angular/core';
import { NavParams, Events, LoadingController, ModalController, ToastController } from 'ionic-angular';
import { GlobalConfig } from '../../app/app.config';
import { SelectEvent } from '../select-event/select-event';
import { Translate } from '../../providers/translate';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-room',
  templateUrl: 'room.html'
})
export class RoomPage {

  client: any;
  eventList: any;
  eventSelected: any = 0;
  textTranslate: any;

  constructor(public params: NavParams, public events: Events, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public toastCrl: ToastController, translate: Translate, public translateProvider: TranslateService, public storage: Storage) {
    translate.translateGroup(['Debe seleccionar un evento'])
    .then((result) => {
      this.textTranslate = result
    });

    this.client = this.params.get('client');
    this.eventList = this.params.get('eventList');

    this.translateProvider.setDefaultLang(this.client.defaultLang || GlobalConfig._defaultLang);
    // this.storage.get("defaultLanguage").then(data => {
    //   if (data) {
    //     console.log('idioma en cahce', data,this.client)
    //     this.translateProvider.setDefaultLang(data);
    //   } else {
    //     this.translateProvider.setDefaultLang(this.client.defaultLang || GlobalConfig._defaultLang);
    //   }
    // });
  }

  select() {
    let modal = this.modalCtrl.create(SelectEvent, {eventList: this.eventList, client: this.client});
    modal.present();
    modal.onDidDismiss((data) => {
      if (data.selected) {
        this.eventSelected = data.selected;
        this.next();
      } else {
        let toast = this.toastCrl.create({
          message: this.textTranslate['Debe seleccionar un evento'],
          duration: 3000
        });
        toast.present();
      }
    });
  }

  next() {
    let loader = this.loadingCtrl.create({
      dismissOnPageChange: true
    });
    loader.present();

    setTimeout(() => {
      this.events.publish('client:event-selected', this.eventSelected);
    }, 1000);
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/room/room.ts